import { z } from "zod";
import { ALERT_MODES, ALERT_SEVERITIES } from "@/isomorphic/constants/workflow-phase-consts";
import { TriggeredConditionSchema } from "./triggered-condition";

// ============================================================================
// BASE TRIGGERED ALERT SCHEMA (matches backend DbTriggeredAlert)
// ============================================================================

// To sync with DbTriggeredAlert in backend/schemas/triggered-alert.ts
// This matches the triggered_alert_view
const BaseTriggeredAlertSchema = z.object({
  // Primary fields
  id: z.string(),

  // Relations
  followUpId: z.string(),
  phaseId: z.string().nullable().optional(),
  callAttemptId: z.string().nullable().optional(),

  // Alert definition (from protocol JSONB)
  alertId: z.string(), // ID de l'alerte dans le protocol
  name: z.string(),
  description: z.string().nullable().optional(),
  mode: z.enum(ALERT_MODES),
  severity: z.enum(ALERT_SEVERITIES),
  message: z.string(),

  // Triggered conditions (array of conditions that triggered this alert)
  triggeredConditions: z.array(TriggeredConditionSchema),

  // Timestamps
  triggeredAt: z.string(),

  // Auto-calculated from actions
  acknowledged: z.boolean(),
  resolved: z.boolean(),

  createdAt: z.string(),
  updatedAt: z.string(),
});

export const TriggeredAlertSchema = BaseTriggeredAlertSchema;

export const TriggeredAlertListItemSchema = BaseTriggeredAlertSchema.extend({
  patientName: z.string().nullable().optional(),
  followUpStatus: z.string().nullable().optional(),
});

export const TriggeredAlertListSchema = z.array(TriggeredAlertListItemSchema);

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type TriggeredAlert = z.infer<typeof TriggeredAlertSchema>;
export type TriggeredAlertListItem = z.infer<typeof TriggeredAlertListItemSchema>;
